import { api } from '../baseApi';
import { makeRequest } from '../makeRequest';
import type {
  DTCAudienceQualityScoreRequest,
  DTCAudienceQualityScoreResponse,
  DTCQuotaInfoRequest,
  DTCQuotaInfoResponse,
  PublishDTCAudienceRequest,
  PublishDTCAudienceResponse,
  RequestDTCAudienceRequest,
  RequestDTCAudienceResponse,
  SelectDTCAudienceRequest,
  SelectDTCAudienceResponse,
} from './dto';
import { DTCAPIRoutes } from './route';

export function requestDTCAudience(body: RequestDTCAudienceRequest): Promise<RequestDTCAudienceResponse> {
  const { userEmail, workspaceID, lookerFilters = {}, retryAfterFailure } = body;
  return makeRequest(
    api.post(
      DTCAPIRoutes.requestAudience(),
      {
        lookerFilters: lookerFilters,
        retryAfterFailure: retryAfterFailure ?? false,
      },
      {
        headers: {
          bi_workspace_id: workspaceID,
          user_email: userEmail,
        },
      },
    ),
  );
}

export function getDTCAudienceQualityScore(
  body: DTCAudienceQualityScoreRequest,
): Promise<DTCAudienceQualityScoreResponse['data']> {
  const { workspaceID, token, granularity = 'PERCENTILE' } = body;
  return makeRequest(
    api.get(DTCAPIRoutes.audienceQualityScore(), {
      params: {
        token,
        granularity,
      },
      transformResponse: (data) => {
        const parsedData: DTCAudienceQualityScoreResponse = JSON.parse(data);
        return parsedData.data;
      },
      headers: {
        bi_workspace_id: workspaceID,
      },
    }),
  );
}

export function getDTCQuotaInfo(body: DTCQuotaInfoRequest): Promise<DTCQuotaInfoResponse> {
  const { workspaceID, accountID, userEmail, advertiserID } = body;
  return makeRequest(
    api.get(DTCAPIRoutes.quotaInfo(), {
      params: {
        accountID,
        userEmail,
        advertiserID,
      },
      headers: {
        bi_workspace_id: workspaceID,
      },
    }),
  );
}

export function publishDTCAudience(body: PublishDTCAudienceRequest): Promise<PublishDTCAudienceResponse> {
  const { workspaceID, userEmail, granularity, range } = body;
  return makeRequest(
    api.post(
      DTCAPIRoutes.publishAudience(),
      {
        granularity,
        range,
        userEmail,
        workspaceID,
      },
      {
        headers: {
          bi_workspace_id: workspaceID,
          user_email: userEmail,
        },
      },
    ),
  );
}

export function selectDTCAudience(body: SelectDTCAudienceRequest): Promise<SelectDTCAudienceResponse> {
  const { workspaceID, userEmail, granularity, range } = body;
  return makeRequest(
    api.post(
      DTCAPIRoutes.selectAudience(),
      {
        granularity,
        range,
        userEmail,
        workspaceID,
      },
      {
        headers: {
          bi_workspace_id: workspaceID,
        },
      },
    ),
  );
}
